import authRules from '../authRules.js';

const viewAssignmentSalaryLevelAndUpgrade = (user) => {
  const { massiveApprovalsSalary } = user.securityLevels;
  if (massiveApprovalsSalary >= authRules.viewAssignmentSalaryLevelAndUpgrade.massiveApprovalsSalary) {
      return true;
  } else {
      return false;
    }
  }


export default viewAssignmentSalaryLevelAndUpgrade;